// extracted by mini-css-extract-plugin
export var link = "_d-0";